/**
 * @generated SignedSource<<65540c8523b0400e06d08825b4571b7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedCondensedSkuAttributes_item$data = {
  readonly isMultiSku: boolean;
  readonly isRingItem: boolean | null;
  readonly skus: ReadonlyArray<{
    readonly serviceId: string | null;
    readonly variableAttributeRows: ReadonlyArray<{
      readonly label: string | null;
      readonly value: string | null;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"SwatchSelectorMinimal_item">;
  readonly " $fragmentType": "PdpSharedCondensedSkuAttributes_item";
};
export type PdpSharedCondensedSkuAttributes_item$key = {
  readonly " $data"?: PdpSharedCondensedSkuAttributes_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedCondensedSkuAttributes_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedCondensedSkuAttributes_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SwatchSelectorMinimal_item"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMultiSku",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRingItem",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "skus",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "VariableAttributeRow",
          "kind": "LinkedField",
          "name": "variableAttributeRows",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "label",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "46eea0f48a5dc17c1e084000bba0d68d";

export default node;
